export default __webpack_public_path__ + "static/media/post-10.e7500834.jpg";